import { render, staticRenderFns } from "./ImmediateTravelNote.vue?vue&type=template&id=276e5db5&scoped=true&"
import script from "./ImmediateTravelNote.vue?vue&type=script&lang=js&"
export * from "./ImmediateTravelNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e5db5",
  null
  
)

export default component.exports